import { LocationNode } from './types';

/**
 * Check if node is fully selected
 */
export const isFullySelected = (
  node: LocationNode,
  selection: Record<string, boolean>
): boolean => {
  if (!node.children || node.children.length === 0) return !!selection[node.id];
  return node.children.every((child) => isFullySelected(child, selection));
};

/**
 * Check if node is partially selected (some children selected)
 */
export const isPartiallySelected = (
  node: LocationNode,
  selection: Record<string, boolean>
): boolean => {
  if (!node.children || node.children.length === 0) return false;
  const someSelected = node.children.some(
    (child) => isFullySelected(child, selection) || isPartiallySelected(child, selection)
  );
  const allSelected = node.children.every((child) => isFullySelected(child, selection));
  return someSelected && !allSelected;
};
